<template>
  <div>
    <sign-up v-if="info.trainProject && info.trainProject['type_id'] == 1" :project-id="info.trainProject.id"
      :class-id="info.id" :project-name="info.name" v-bind:is-sign-up.sync="isSignUp" />
    <sign-up-zz v-if="info.trainProject && info.trainProject['type_id'] == 4" :project-id="info.trainProject.id"
      :class-id="info.id" v-bind:is-sign-up-zz.sync="isSignUp" />
    <Top />
    <div class="maindiv pproject-wrap  bg-gray">
      <Banner />
      <div class="mt160 bgw htmldiv">
        <banner-title v-if="info.trainProject" :trainType="info.trainProject['type_id']" :itemName="info.name" />
        <div class="detail" v-if="info.trainProject">
          <div class="pbm mb45">
            <div class="fs20 nm pl30 pr30 pt10 pb10 lh18 br2">
              <span v-if="info.train_hour" class="fr tc-blue3 fs14 mt5">培训课时：{{ info.train_hour }}</span>
              {{ info.name }}
            </div>
            <div class="mt20 mb5 prelative dflex align-items-center">
              <div class="pabsolute line"></div>
              
              <div class="dinline-block ld pl10 pr20 fs14">
                <!-- <div v-if="info.trainProject.train_type" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">培训类型：</span>
                    <span class="tc-blue2">{{ info.trainProject.train_type }}</span>
                  </div>
                </div> -->
                <div v-if="info.trainProject.train_obj" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">培训对象：</span>
                    <span class="tc-blue2">{{ info.trainProject.train_obj }}</span>
                  </div>
                </div>
                <div v-if="info.trainProject.train_add" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">办班地点：</span>
                    <span class="tc-blue2">{{ info.trainProject.train_add }}</span>
                  </div>
                </div>
                <template v-if="info.trainProject.type_id == 5">
                  <!-- <div v-if="info.trainProject.period" class="dsn dinline-block mb10">
                    <div class="dflex">
                      <span class="tst">期数：</span>
                      <span class="tc-blue2">{{ info.trainProject.period }}22</span>
                    </div>
                  </div> -->
                  <div v-if="info.trainProject.train_type" class="dsn dinline-block mb10">
                    <div class="dflex">
                      <span class="tst">作业类别：</span>
                      <span class="tc-blue2">{{ info.trainProject.train_type }}</span>
                    </div>
                  </div>
                  <div v-if="info.trainProject.train_project" class="dsn dinline-block mb10">
                    <div class="dflex">
                      <span class="tst">准操项目：</span>
                      <span class="tc-blue2">{{ info.trainProject.train_project }}</span>
                    </div>
                  </div>
                </template>
                <!-- <div v-if="info.trainProject.deadline" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">报名截止时间：</span>
                    <span class="tc-blue2">{{info.trainProject.deadline}}</span>
                  </div>
                </div> -->
                <div v-if="info.enroll_end_dt" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">报名截止时间：</span>
                    <span class="tc-blue2">{{ info.enroll_end_dt }}</span>
                  </div>
                </div>
                <div v-if="info.start_dt" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">培训开始时间：</span>
                    <span class="tc-blue2">{{ info.start_dt }}</span>
                  </div>
                </div>
                <div v-if="info.end_dt" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">培训结束时间：</span>
                    <span class="tc-blue2">{{ info.end_dt }}</span>
                  </div>
                </div>
                <div v-if="info.link_man" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">联系人：</span>
                    <span class="tc-blue2">{{ info.link_man }}</span>
                  </div>
                </div>
                <div v-if="info.link_tel" class="dsn dinline-block mb10">
                  <div class="dflex">
                    <span class="tst">联系电话：</span>
                    <span class="tc-blue2">{{ info.link_tel }}</span>
                  </div>
                </div>
              </div>
              <div class="dinline-block vtop ztns">
                <div class="dflex dflex-column justify-content-center">
                  <a v-if="info.trainProject" href="javascript:;" class="mat dblock zbtn mb10 zbtn-gblue2 br5 fs16 hbig"
                    id="bm" @click="showSign(info)">立即报名</a>
                  <template v-if="info.trainProject.type_id == 3 || info.trainProject.type_id == 5">
                  </template>
                  <template v-if="info.trainProject.type_id != 4">
                    <a href="javascript:;" class="pn mat dblock zbtn zbtn-gblue2 br5 mb10 fs16 hbig prelative">
                      手机报名
                      <div class="dimg dnone pabsolute bgw pt10">
                        <div class="qrcode-div" :id="'qrcode-item-div' + info.id">
                        </div>
                        <div class="fs12 tc9 mt5">扫一扫，手机报名</div>
                      </div>
                    </a>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="item-class">【培训项目简介】</div>
          <div class="tc6 fs14 item-content ncont" v-html="info.infor"></div>
          <div class="item-class">【课程安排】</div>
          <div class="tc6 fs14 item-content ncont">
            <div v-if="info.teachingTask">
              <!-- <div>计划名称：{{ item.name }}</div> -->
              <div style="margin-top: -20px;font-size: 18px;font-weight: bold;padding: 0 20px;color: #333;">计划详情：</div>
              <div style="padding: 0 40px;font-size: 15px;" v-for="item_ in info.teachingTask" :key="item_.id">
                {{ item_.course.name }}{{ item_.tea_name ? ' - ' + item_.tea_name : ''}}  
              </div>
            </div>
          </div>
          <!--          <div class="item-class">【报名手续及联系方式】</div>-->
          <!--          <div class="tc6 fs14 item-content" v-html="info.memo"></div>-->
        </div>
      </div>
      <div data-v-fd68d6dc="" class="ht30"></div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../top'
import Banner from '../banner'
import Bottom from '../bottom'
import BannerTitle from './ttitle'
import SignUp from './signUp'
import SignUpZz from './signUpZz'
import QRCode from 'qrcodejs2'
export default {
  name: 'detail',

  components: {
    Top,
    Banner,
    Bottom,
    BannerTitle,
    SignUp,
    SignUpZz
  },

  data() {
    return {
      'info': {},
      'isSignUp': false,
      'isSignUpZz': false,
      'trainName': '',
      'is_code': 0
    }
  },

  watch: {
    info: {
      deep: true,
      handler(newName, oldName) {
        this.$nextTick(() => {
          let item = this.info
          if (item && item.id && !this.is_code) {
            this.creatQrCode('qrcode-item-div' + item.id, item.id, item.name, item.trainProject.id)
            this.is_code = 1
          }
        })
      }
    }
  },
  created() {
    var id = this.$route.query.id
    if(this.$route.query.period)
      id = this.$route.query.period
    //var period = this.$route.query.period
    var getParam = {}
    //console.log(period)
    getParam['id'] = id
    this.$request.get('training-skill/detail', getParam, response => {
      if (response.status == 200) {
        this.info = response.data.data.jobClass;
        //console.log( this.info)
      }
    }, error => {
      console.log(error)
    })
  },

  mounted() {
    // this.initImg()
    // fconsole.log(this.info.jobDiscipline)
  },

  methods: {
    creatQrCode(qrCodeUrl, id, name, project_id) {
      var docd = document.getElementById(qrCodeUrl)
      // console.log(docd)
      var that = this
      let info = this.info
      let trainProject = info.trainProject
      if (docd) {
        docd.innerHTML = ''
        let work_option = trainProject.work_option
        let txt = 'http://' + document.domain + that.$router.options.base + 'mobile/train/project/sign?id=' + id +
          '&name=' + name + '&work_option=' + work_option + '&project_id=' + project_id

        if (trainProject.type_id == 5) {
          id = trainProject.id
          let period = info.id
          txt = 'http://' + document.domain + that.$router.options.base + 'mobile/train/project/sign-up-tz?id=' + id +
            '&period=' + period + '&project_id=' + project_id
        } else if (trainProject.type_id == 1) { //社会培训
          txt = 'http://' + document.domain + that.$router.options.base + 'mobile/train/project/sign-up?id=' + id +
            '&project_name=' + trainProject.name + '&project_id=' + project_id

        }
        var qrcode = new QRCode(docd, {
          text: txt, // 需要转换为二维码的内容
          width: 115,
          height: 115,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    showSign: function (item) {
      let { trainProject } = item
      let type = trainProject['type_id']
      if (type == 5) // 特种工
      {
        this.$router.push({
          path: '/train/project/sign-up-tz',
          query: {
            id: trainProject.id,
            flow: 1,
            period: item.id
          }
        })
      } else if (type == 3) { // 技能
        localStorage.setItem('ITEMJN', item.work_option)
        this.$router.push(`/train/project/sign?project_id=${trainProject.id}&id=${item.id}&name=${item.name}&flow=1`)
      } else { this.isSignUp = true }
    },
    goSearch(item) {
      let { trainProject } = item
      let type = trainProject['type_id']
      if (type == 5) {
        this.$router.push({
          path: '/train/project/sign-up-tz',
          query: {
            id: trainProject.id,
            flow: 4
          }
        })
      } else if (type == 3) {
        this.$router.push(`/train/project/sign?id=${item.id}&project_id=${trainProject.id}&name=${item.name}&flow=2`)
      }
    },
    hiddenSign: function () {
      this.isSignUp = false
    },
    initImg: function () {
      this.imgSrc = this.$request.request_url + 'training-skill/image-code?unique_code=' + this.$elId + '&random=' +
        Math.random()
    },
    subSigUp: function () {
      var id = this.$route.query.id
      var getParam = {}
      getParam['discipline_id'] = id
      getParam['phone'] = this.signPhone
      getParam['name'] = this.signName
      getParam['cid'] = this.cid
      getParam['code'] = this.signCode
      getParam['unique_code'] = this.$elId
      this.$request.post('training-skill/enroll', getParam, response => {
        if (response.status == 200) {
          // this.info = response.data.data;
          if (response.data.code == 200) {
            alert('报名成功')
            this.isSignUp = false
          } else {
            alert(response.data.message)
          }
        }
      }, error => {
        console.log(error)
      })
    },

  }
};
</script>

<style scoped>
.pproject-wrap .detail {
  padding: 50px 55px 80px;
}

.pbm {
  border: 1px solid #147ad8;
}

.pbm .nm {
  border-bottom: 1px solid #147ad8;
  background: #f0f6ff;
  color: #000;
}

.pbm .ld {
  width: 925px;
}

.pbm .line {
  left: 925px;
  background: #1492ff;
  width: 1px;
  top: -5px;
  bottom: 10px;
}

.pbm .dsn {
  padding-left: 20px;
  width: 280px;
}

.pbm .tst {
  flex-shrink: 0;
  color: #000;
}

.ztns {
  width: 233px;
}

.pbm .zbtn {
  display: block;
  padding: 10px 0;
  width: 150px;
  line-height: 1;
  background: white;
  color: #1492ff;
  border: 1px solid #1492ff;
}

.pbm .zbtn:hover {
  background: #1492ff;
  color: #fff;
}

.item-class {
  margin-left: -10px;
  font-size: 20px;
  font-weight: bold;
}

.item-content {
  padding: 30px 0;
  line-height: 2;
  text-align: justify;
}

.tc-blue2 {
  color: #333;
}

.tc-blue3 {
  color: #147ad8;
}

.dimg {
  z-index: 2;
  left: 0;
  right: 0;
  top: 101%;
  padding: 15px 15px 10px;
  box-shadow: 0 0 5px #ccc;
}

.pn:hover .dimg {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/train/project/detail.vue